import React from "react";
import {useNavigate} from "react-router-dom";
import {Button} from "react-bootstrap";

export const TableButton = ({onClick, icon, className, children, href, title, variant}) => {

    const navigate = useNavigate();

    const goTo = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(href);
        }
    }

    return (
        <Button onClick={goTo} className={className} variant={variant} title={title} size="sm" style={{marginRight: '10px'}}>
            {icon && <i className={icon}>  &nbsp;</i>}
            {children}
        </Button>
    )
}
